import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import SectionHero4 from "components/SectionHero/SectionHero";
import { useEffect } from "react";
import CarLogo from "components/CarLogo/CarLogo";
import DriveLuxury from "components/DriveLuxury/DriveLuxury";
import WhyChooseUS from "containers/StartEarning/WhyUs";

import BenefitsSection from "components/BenifitsSection/BeifitSection";
import StepsSection from "components/Steps/Steps";
import LocationSection from "components/LocationSection/LocationSection";

function PageHome3() {
  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  return (
    <div className="nc-PageHome3 relative overflow-hidden">
      <SectionHero4 />

      <div className="container relative py-24">
        <CarLogo />
      </div>
      <div className="container relative py-16  ">
        <SectionGridFeaturePlaces />
      </div>

      <div className="container relative py-16">
        <DriveLuxury />
      </div>
      <div className="container relative py-16">
        <BenefitsSection />
      </div>
      <div className="container relative py-16">
        <StepsSection />
      </div>
      <div className="container relative py-16">
        <LocationSection />
      </div>

      <div className="container py-16">
        <div className=" rounded-2xl bg-[#FFFFFF0D]">
          <div className="relative py-6 ">
            <SectionClientSay uniqueClassName="PageAbout_" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageHome3;
